import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Box,
  ButtonBase,
  Dialog,
  makeStyles,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import moment from 'moment';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { GenderIcon } from '../../../../../components';
import { CloseIcon, SeeIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import BedStatusIcon from '../../BedStatusIcon';
import { baseCssOccupieddischarge } from '../baseCss';
import CancelConfirmation from '../CancelConfirmation';
import { bedStatusAPI } from '../../../../../apis';
import bsApp, { bedP as P } from '../../../bsApp';
import RemaksIcon from '../../BedStatusIcon/RemaksIcon';
import { bsMlookupListFunc } from '../../../bsEnumeration';
import { bsAttentionFunc } from '../../../bsAttention';
import Newbooking from '../Newbooking';
import TransferOutPop from '../TransferOutPop';
import { alertMsg, ResponseCommCodeEnum } from '../../../../../apis/commlogic';
import eventBus from '../../../../../utils/eventBus';
import { initValue } from '../../../../../utils';
import ServiceHistoryPopup from '../../ServiceOrder/ServiceHistoryPopup';
import { OrderedCleaningService } from '../../ServiceOrder';
import ServiceOrderBtn from '../../ServiceOrder/ServiceOrderBtn';
import handleGetBsCleansingType from '../../../../../utils/handleGetBsCleansingType';
import admissionUtil from '../../../../../utils/admissionUtil';
import { PatientUI } from '../../InternalBooking/TransferInTable/Row';
const useStyles = makeStyles((theme) => ({
  remarksItemLabel: {
    flexBasis: '50%',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#2e4469',
  },
  remarksItemValue: {
    flexBasis: '50%',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#7d86a9',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
  },
  remaksText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    fontWeight: '500',
    color: '#2e4469',
    marginLeft: '0.688rem',
  },
  dialog: {
    '& .MuiPaper-root': {
      width: '95rem',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      background: 'transparent',
      boxShadow: 'unset',
    },
  },
  root: {
    // width: '80rem',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    background: '#fff',
    minHeight: '45rem',
    overflow: 'auto',
    minWidth: '100%',
    maxWidth: '95rem',
    paddingTop: '2rem',
    position: 'relative',
  },
  attentionItem: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    paddingTop: '0.5rem',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
  },
  seeBtn: {
    width: '2.25rem',
    height: '2.25rem',
    minWidth: '2.25rem',
    backgroundColor: '#4c93ff',
    borderRadius: '0.625rem',
    color: '#fff',
    marginLeft: '0.25rem',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
  seeIcon: {
    fontSize: '1.5rem',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
}));

export default function Canceldischarge({ closePop, allData, open, updateBedStatus }) {
  const baseClasses = baseCssOccupieddischarge();
  const classes = useStyles();
  const loginInfo = useSelector((state) => state.loginInfo);
  const isolationPrecaution = [
    { typeName: bsApp.AIRBORNE_PRECAUTION, text: i18n.t('BEDSTATUS_AIRBORNE_PRECAUTION'), key: P.airbornePrecaution },
    { typeName: bsApp.DROPLET_PRECAUTION, text: i18n.t('BEDSTATUS_DROPLET_PRECAUTION'), key: P.dropletPrecaution },
    { typeName: bsApp.CONTACT_PRECAUTION, text: i18n.t('BEDSTATUS_CONTACT_PRECAUTION'), key: P.contactPrecaution },
    { typeName: bsApp.REVERSE_LSOLATION, text: i18n.t('BEDSTATUS_REVERSE_LSOLATION'), key: P.reverseLsolation },
    { typeName: bsApp.COVID_19, text: i18n.t('BEDSTATUS_COVID_19'), key: P.covidPositivePat },
  ];

  const [BsMlookupList, setBsMlookupList] = useState(null);
  const [transferInPop, setTransferInPop] = useState(null);
  const [sendBtn, setSendBtn] = useState(false);
  const [transferOutPop, setTransferOutPop] = useState(false);
  const [transferOutDetail, setTransferOutDetail] = useState(null);
  const [transferOutDetailBoolean, setTransferOutDetailBoolean] = useState(false);
  const [transferInDetail, setTransferInDetail] = useState(null);
  const [servicePopup, setServicePopup] = useState(false);

  const disabledData = {
    hospitalNo: true,
    hospitalCode: true,
    retrieve: true,
    name: true,
    age: true,
    specialtyCode: true,
    gender: true,
    ward: true,
    bedNo: true,
  };
  const transferOutSchema = {
    hospitalNo: true,
    hospitalCode: true,
    name: true,
    age: true,
    gender: true,
    status: Boolean(sendBtn),
  };

  const getBsMlookupList = async () => {
    const getBsMlookupList = await bedStatusAPI.getBsMlookupList();
    setBsMlookupList(getBsMlookupList?.result);
  };

  const [BsAttentionList, setBsAttentionList] = useState(null);
  const getBsAttentionList = async () => {
    const { result } = await bedStatusAPI.getBsAttentionList();
    Array.isArray(result) && setBsAttentionList(result);
  };

  useEffect(() => {
    (async () => {
      try {
        await getBsMlookupList();
        await getBsAttentionList();
      } catch {}
    })();
  }, []);

  const [isCancelConfirmationPop, setIsCancelConfirmationPop] = useState(false);
  const closeCancelConfirmationPop = () => {
    setIsCancelConfirmationPop(false);
  };
  const showCancelConfirmationPop = () => {
    setIsCancelConfirmationPop(true);
  };

  const getCurrentWard = () => {
    const admDtmM = moment(allData?.[P.currentWard_admDtm]);
    const isVaild = admDtmM.isValid();
    const startTime = admDtmM.format('YYYY-MM-DD');
    const endTime = moment().format('YYYY-MM-DD');
    const DiffDay = moment(endTime).diff(startTime, 'days');
    return isVaild ? DiffDay : '';
  };

  const confirmHandle = async (params = {}) => {
    try {
      await updateBedStatus(
        {
          ...allData,
          targetStatus: bsApp.OCCUPIED,
          sourceStatus: bsApp.DISCHARGING,
          ...params,
        },
        closePop
      );
    } catch {}
  };

  const getLsolationPrecaution = () => {
    const result = _.map(isolationPrecaution, (item) => {
      return allData?.[item.key] ? (
        <div key={item.text} style={{ margin: '1rem 0' }}>
          <Box display="flex" alignItems="center">
            <RemaksIcon typeName={item.typeName} />
            <Typography className={classes.remaksText}>{item.text}</Typography>
          </Box>
        </div>
      ) : (
        <div />
      );
    });
    return result.reduce((preItem, nexItem) => preItem + nexItem) ? (
      result
    ) : (
      <Typography className={classes.remarksItemValue}>{i18n.t('BEDSTATUS_N_A')}</Typography>
    );
  };

  const getAttention = () => {
    const temp = bsAttentionFunc.getSortNameStr(BsAttentionList, allData?.[P.attention]);
    return initValue(temp);
  };

  const closeTransferInPop = () => {
    setTransferInPop(false);
  };

  const openTransferIn = async () => {
    await getBsTransferInRequestDetailApi();
    setTransferInPop(true);
    await getBsMlookupList();
  };
  const getBsMlookupListApi = async () => {
    try {
      const getBsMlookupList = await bedStatusAPI.getBsMlookupList();
      setBsMlookupList(getBsMlookupList.result);
    } catch (error) {
      console.log('-----Ward error-----', error);
    }
  };

  const getBsTransferOutRequestDetailApi = useCallback(async () => {
    try {
      const { result } = await bedStatusAPI.getBsTransferOutRequestDetail({
        transferRequestId: allData?.transferOutRequestInfo?.transferRequestId,
      });
      setTransferOutDetail(result);
    } catch (error) {}
  }, []);

  const openTransferOut = async () => {
    await getBsMlookupListApi();
    await getBsTransferOutRequestDetailApi();
    setSendBtn(false);
    setTransferOutDetailBoolean(true);
    setTransferOutPop(true);
  };

  const closeTransferOutPop = () => {
    setTransferOutPop(false);
  };

  // update
  const editSaveHandle = async (requestVal) => {
    try {
      await bedStatusAPI.postUpdateBsTransferOutRequest(requestVal);
      eventBus.emit('BSRELOAD');
      closePop();
      return true;
    } catch (error) {
      if (error.statusCode === ResponseCommCodeEnum.BED_VERSION) {
        alertMsg(
          i18n.t(
            'BEDSTATUS_THE_TRANSFER_IN_DETAIL_WAS_CHANGED_BY_OTHER_WARDPLACE_USER_PLEAS_REFRESH_WEB_PAGE_TO_GET_THE_LATEST_TRANSFER_IN_INFO_AND_CHECK_IF_FURTHER_ACTION_IS_REQUIRED'
          ),
          _.uniqueId('warning_'),
          'warning'
        );
      } else {
        console.log(`---------${error}------------`);
      }
    }
  };

  const bsMlookupListStatus = useMemo(() => {
    let addStatus = [
      { lookUpName: i18n.t('BEDSTATUS_PENDING'), lookUpValue: 'P' },
      { lookUpName: i18n.t('BEDSTATUS_DELETED'), lookUpValue: 'D' },
    ];
    return addStatus;
  }, [BsMlookupList]);

  const getBsTransferInRequestDetailApi = useCallback(async () => {
    try {
      const { result } = await bedStatusAPI.getBsTransferRequestDetail({
        transferRequestId: allData?.transferInRequestInfo?.transferRequestId,
      });
      setTransferInDetail(result);
    } catch (error) {}
  }, []);

  const editTransferInSaveHandle = async (requestVal, editIndex) => {
    try {
      await bedStatusAPI.postUpdateBsBooking(requestVal);
      eventBus.emit('BSRELOAD');
      closePop();
      return true;
    } catch (error) {
      if (error.statusCode === ResponseCommCodeEnum.BED_VERSION) {
        alertMsg(
          i18n.t(
            'BEDSTATUS_THE_TRANSFER_IN_DETAIL_WAS_CHANGED_BY_OTHER_WARDPLACE_USER_PLEAS_REFRESH_WEB_PAGE_TO_GET_THE_LATEST_TRANSFER_IN_INFO_AND_CHECK_IF_FURTHER_ACTION_IS_REQUIRED'
          ),
          _.uniqueId('warning_'),
          'warning'
        );
      } else {
        console.log(`---------${error}------------`);
      }
    }
  };

  const bsMlookupListTransferInStatus = useMemo(() => {
    let addStatus = [
      { lookUpName: i18n.t('BEDSTATUS_OUTSTANDING'), lookUpValue: 'O' },
      { lookUpName: i18n.t('BEDSTATUS_COMPLETED_SINCE_24HOURS_AGO'), lookUpValue: 'C' },
      { lookUpName: i18n.t('BEDSTATUS_DELETED'), lookUpValue: 'D' },
    ];
    return addStatus;
  }, [BsMlookupList]);

  const patientName = admissionUtil?.useGetName({
    chiName: allData?.patInfo?.chiName,
    engName: allData?.patInfo?.engName,
    loginFlag: loginInfo?.flag,
  });

  return (
    <>
      <DialogComp
        isCancelConfirmationPop={isCancelConfirmationPop}
        transferInPop={transferInPop}
        transferOutPop={transferOutPop}
        classes={classes}
        baseClasses={baseClasses}
        closePop={closePop}
        allData={allData}
        open={open}
        getCurrentWard={getCurrentWard}
        getLsolationPrecaution={getLsolationPrecaution}
        BsMlookupList={BsMlookupList}
        openTransferOut={openTransferOut}
        getAttention={getAttention}
        showCancelConfirmationPop={showCancelConfirmationPop}
        openTransferIn={openTransferIn}
        servicePopup={servicePopup}
        setServicePopup={setServicePopup}
        patientName={patientName}
      />
      {isCancelConfirmationPop ? (
        <CancelConfirmation
          allData={allData}
          closePop={closeCancelConfirmationPop}
          open={isCancelConfirmationPop}
          confirmHandle={confirmHandle}
        />
      ) : (
        ''
      )}
      {transferInPop && (
        <Newbooking
          open={transferInPop}
          title={i18n.t('BEDSTATUS_TRANSFER_IN')}
          closePop={closeTransferInPop}
          bsMlookupList={BsMlookupList}
          allData={transferInDetail}
          saveHandle={editTransferInSaveHandle}
          bsMlookupListStatus={bsMlookupListTransferInStatus}
        />
      )}
      {transferOutPop && (
        <TransferOutPop
          open={transferOutPop}
          closePop={closeTransferOutPop}
          bsMlookupList={BsMlookupList}
          allData={
            transferOutDetail && transferOutDetailBoolean
              ? transferOutDetail
              : {
                  ...allData,
                  wardCd: '',
                  status: 'P',
                  attention: bsAttentionFunc.getSortNameStr(allData?.attention, allData?.attention),
                }
          }
          title={i18n.t('BEDSTATUS_TRANSFER_OUT_BUTTON')}
          disabledData={disabledData}
          transferOutSchema={transferOutSchema}
          sendBtn={sendBtn}
          saveHandle={editSaveHandle}
          bsMlookupListStatus={bsMlookupListStatus}
          covidPositivePatRemarks={sendBtn}
        />
      )}
      {servicePopup && <ServiceHistoryPopup setServicePopup={setServicePopup} />}
    </>
  );
}

const DialogComp = ({
  isCancelConfirmationPop,
  transferInPop,
  transferOutPop,
  classes,
  baseClasses,
  closePop,
  allData,
  open,
  getCurrentWard,
  getLsolationPrecaution,
  BsMlookupList,
  openTransferOut,
  getAttention,
  showCancelConfirmationPop,
  openTransferIn,
  servicePopup,
  setServicePopup,
  patientName,
}) => {
  return !isCancelConfirmationPop && !transferInPop && !transferOutPop && !servicePopup ? (
    <Dialog open={open} maxWidth={false} className={classes.dialog}>
      <div className={classes.root}>
        <DialogBody
          classes={classes}
          baseClasses={baseClasses}
          allData={allData}
          getCurrentWard={getCurrentWard}
          getLsolationPrecaution={getLsolationPrecaution}
          BsMlookupList={BsMlookupList}
          openTransferOut={openTransferOut}
          getAttention={getAttention}
          openTransferIn={openTransferIn}
          setServicePopup={setServicePopup}
          patientName={patientName}
        />
        <ButtonBase
          id="bed_canceldischaarge_close_btn"
          className={baseClasses.closeIcon}
          onClick={closePop}
          style={{ position: 'absolute', right: '2rem' }}
        >
          <CloseIcon />
        </ButtonBase>

        <div className={baseClasses.bottom} style={{ boxShadow: '0 -1px 0 0 #e4e7eb', gap: '1.25rem' }}>
          <ButtonBase
            className={baseClasses.configBtn}
            onClick={showCancelConfirmationPop}
            id="bed_canceldischarge_cancel"
            style={{ width: '18rem', backgroundColor: '#FF655C' }}
          >
            {i18n.t('BEDSTATUS_CANCEL_DISCHARGE_ORDER')}
          </ButtonBase>
          <ServiceOrderBtn
            hospCode={allData?.ccHosp}
            wardLocation={allData?.ccWardLocation}
            version={allData?.version}
            status={allData?.status}
            tableId={allData?.bedStatusId}
            tableName="B"
            closePop={closePop}
            reminder={`bed ${allData.linkedBedNo ?? allData?.bedNo}`}
            allData={allData}
            defaultLocation={`${allData.ccWardLocation} ${allData.ccWardCd ?? allData?.wardCd}`}
            defaultCleaningCase={handleGetBsCleansingType(allData)}
            defaultRemark={`${allData?.ccWardCd ?? allData?.wardCd} 床 ${allData?.bedNo}`}
          />
        </div>
      </div>
    </Dialog>
  ) : (
    <div />
  );
};

const DialogBody = ({
  classes,
  baseClasses,
  allData,
  getCurrentWard,
  getLsolationPrecaution,
  BsMlookupList,
  openTransferOut,
  getAttention,
  openTransferIn,
  setServicePopup,
  patientName,
}) => (
  <Box overflow="auto" p="0 1.56rem" pb="1.87rem" pr="2.87rem">
    <div className={baseClasses.statusBox}>
      <div className={baseClasses.status}>
        <BedStatusIcon allData={allData} disabled={true} />
      </div>
      <PatientUI
        ehAddrInfo={allData?.[P.elderlyHome]}
        iconBoxSize="2rem"
        caseNo={initValue(allData?.[P.patientID], i18n.t('BEDSTATUS_N_A'))}
        name={patientName}
        gender={allData?.[P.gender]}
        age={initValue(allData?.[P.age], i18n.t('BEDSTATUS_N_A'))}
      />
    </div>
    <Box display="flex" mt="1.188rem">
      <div className={baseClasses.columnBox} style={{ paddingLeft: '1.875rem', marginRight: '1.25rem' }}>
        <Typography className={baseClasses.labelText}>{i18n.t('BEDSTATUS_CURRENT_WARD')}</Typography>
        <Typography className={baseClasses.statusText}>{allData?.[P.totalDats] ?? ''}</Typography>
      </div>
      <div className={baseClasses.columnBox} style={{ paddingLeft: '1.875rem' }}>
        <Typography className={baseClasses.labelText}>{i18n.t('BEDSTATUS_TOTAL_DAYS')}</Typography>
        <Typography className={baseClasses.statusText}>{getCurrentWard()}</Typography>
      </div>
    </Box>
    <Typography className={baseClasses.others} style={{ margin: '1.85rem 0 0 0' }}>
      {i18n.t('BEDSTATUS_REMARKS')}
    </Typography>
    <Box display="flex">
      <Box flexBasis="50%" display="grid" gridTemplateColumns="1fr 1fr 1fr" mt="1.25rem" gridRowGap="2.5rem">
        <Box>
          <Typography className={classes.remarksItemLabel} style={{ marginBottom: '0.625rem' }}>
            {i18n.t('BEDSTATUS_ISOLATION_PRECAUTION')}
          </Typography>
          <Box>{getLsolationPrecaution()}</Box>
          {allData?.covidPositivePat && (
            <>
              <Typography className={classes.attentionItem}>
                {/* COVID info: {allData.covidPositivePat?.[0].covidDescription} */}
                {i18n.t('BEDSTATUS_REPORT_TIME')}
                {allData?.covidPositivePat
                  ? moment(allData?.covidPositivePat?.[0].reportDtm).format('DD MMMM YYYY HH:MM')
                  : ''}
              </Typography>
              <Typography className={classes.attentionItem}>
                {i18n.t('BEDSTATUS_CT_VALUE')}
                {allData?.covidPositivePat?.[0].ctValue}
              </Typography>
              <Typography className={classes.attentionItem}>
                {allData?.covidPositivePat?.[0].covidDescription}
              </Typography>
              <Typography className={classes.attentionItem}>
                {i18n.t('BEDSTATUS_COUNTER')}
                {allData?.covidPositivePat && (
                  <>
                    {Math.round(
                      (moment().valueOf() - allData?.covidPositivePat?.[0].reportDtm) / (24 * 60 * 60 * 1000)
                    )}{' '}
                    {i18n.t('BEDSTATUS_DAY')}
                  </>
                )}
              </Typography>
            </>
          )}
        </Box>
        <Box>
          <Typography className={classes.remarksItemLabel} style={{ marginBottom: '0.625rem' }}>
            {i18n.t('BEDSTATUS_MISSING')}
          </Typography>
          <Typography className={classes.remarksItemValue}>
            {allData?.[P.missingCaseCloseTime]
              ? moment(allData?.[P.missingCaseCloseTime]).format('DD-MM-yyyy HH:mm')
              : i18n.t('BEDSTATUS_N_A')}
          </Typography>
        </Box>
        <Box>
          <Typography className={classes.remarksItemLabel} style={{ marginBottom: '0.625rem' }}>
            {i18n.t('BEDSTATUS_DISCHARGE_DESTINATION')}
          </Typography>
          <Typography className={classes.remarksItemValue}>
            {allData?.[P.dischargeDestination]
              ? bsMlookupListFunc.getTypeLookupName(BsMlookupList, 'bs_dischg_dest', allData?.[P.dischargeDestination])
              : i18n.t('BEDSTATUS_N_A')}
          </Typography>
        </Box>

        <Box>
          <Typography className={classes.remarksItemLabel}>{i18n.t('BEDSTATUS_ATTENTION')}</Typography>
          <Typography className={classes.remarksItemValue}>{getAttention()}</Typography>
        </Box>
        <Box>
          <Typography className={classes.remarksItemLabel}>{i18n.t('BEDSTATUS_NEATS_BOOKING')}</Typography>
          <Typography className={classes.remarksItemValue} style={{ marginTop: '0.625rem' }}>
            {allData?.[P.NEATSBooking] ? 'Y' : i18n.t('BEDSTATUS_N_A')}
          </Typography>
        </Box>
        <Box>
          <Typography className={classes.remarksItemLabel}>
            {`${i18n.t('BEDSTATUS_HOME_LEAVE')}(${i18n.t('BEDSTATUS_RETURN_DATE')})`}
          </Typography>
          <Typography className={classes.remarksItemValue} style={{ marginTop: '0.625rem' }}>
            {allData?.[P.homeLeaveDtm]
              ? moment(allData?.[P.homeLeaveDtm]).format('DD-MM-yyyy HH:mm')
              : i18n.t('BEDSTATUS_N_A')}
          </Typography>
        </Box>
        <Box>
          <Typography className={classes.remarksItemLabel} style={{ marginBottom: '0.625rem' }}>
            {i18n.t('BEDSTATUS_TRANSFER_OUT_BUTTON')}
          </Typography>

          {allData?.transferOutRequestInfo ? (
            <Box display="flex" alignItems="center" className={classes.remarksItemValue}>
              {`${moment(allData?.transferOutRequestInfo?.admissionDate).format('yyyy-MM-DD HH:mm')} ${
                allData?.transferOutRequestInfo?.destHospCode
              } ${allData?.transferOutRequestInfo?.destWardCode}`}
              <ButtonBase
                className={classes.seeBtn}
                onClick={() => {
                  (async () => {
                    await openTransferOut();
                  })();
                }}
              >
                <SeeIcon className={classes.seeIcon} />
              </ButtonBase>
            </Box>
          ) : (
            <Typography className={classes.remarksItemValue} style={{ marginTop: '0.625rem' }}>
              {i18n.t('BEDSTATUS_N_A')}
            </Typography>
          )}
        </Box>
        <Box>
          <Typography className={classes.remarksItemLabel}>{i18n.t('BEDSTATUS_PENDING_ADMISSION_POPUP')}</Typography>

          {allData?.transferInRequestInfo ? (
            <>
              <Box
                display="flex"
                alignItems="center"
                className={classes.remarksItemValue}
                style={{ marginTop: '0.625rem' }}
              >
                <div style={{ color: '#7d86a9' }}>
                  {`${moment(allData?.transferInRequestInfo?.admissionDate).format('yyyy-MM-DD HH:mm')} ${
                    allData?.transferInRequestInfo?.hospCode
                  } ${allData?.transferInRequestInfo?.wardCode}`}
                </div>
                <ButtonBase className={classes.seeBtn} onClick={openTransferIn}>
                  <SeeIcon className={classes.seeIcon} />
                </ButtonBase>
              </Box>
              {allData?.transferInRequestInfo?.remark && (
                <Box className={classes.remarksItemValue} style={{ color: '#7d86a9' }}>
                  {i18n.t('BEDSTATUS_RETURN_DAY_CASE')}: {allData?.transferInRequestInfo?.remark}
                </Box>
              )}
            </>
          ) : (
            <Typography className={classes.remarksItemValue} style={{ marginTop: '0.625rem' }}>
              {i18n.t('BEDSTATUS_N_A')}
            </Typography>
          )}
        </Box>
      </Box>

      <OrderedCleaningService
        tableName="B"
        tableId={allData?.bedStatusId}
        handleInfo={() => setServicePopup(true)}
        bedNo={allData?.bedNo}
        reminder={`bed ${allData?.bedNo}`}
      />
    </Box>
  </Box>
);
